import { apiInstance } from "@/utils/ApiUtil.js";
const API_URL = "/giveaway";

const getAll = async (req) => {
    try {
        const response = await apiInstance.get(API_URL + "/all", {
            params: {
                status: req.status,
            }
        });

        if (!response?.data?.success) return false;

        return response.data.items;
    } catch (error) {
        console.log(error);
        return false;
    }
};

const getAllWithDetails = async () => {
    try {
        const response = await apiInstance.get(API_URL + "/all-user", {
        });

        if (!response?.data?.success) return false;

        return response.data.items;
    } catch (error) {
        console.log(error);
        return false;
    }
};

const join = async (req) => {
    try {
        const response = await apiInstance.post(API_URL + "/join", {
            giveaway_id: req.giveaway_id
        });

        return response.data
    } catch (error) {
        console.log(error);
        return {success: false, msg: "Error!"};
    }
};

const GiveawayService = {
    getAll,
    getAllWithDetails,
    join
}

export default GiveawayService;
